










































































import Vue from "vue";

/* Data */
import { form, checkbox, textarea } from "./data/formData";
import { validators } from "./data/validators";

/* Interfaces */
import { IFormInput } from "./interfaces/IFormInput";
import { IValidator } from "./interfaces/IValidator";
import { IParsedFormData } from "./interfaces/IParsedFormData";

/* Components */
import Loader from "@/components/Loader/Loader.vue";

export default Vue.extend({
  data: () => ({
    form: form as Record<string, IFormInput>,
    checkbox: checkbox as IFormInput,
    textarea: textarea as IFormInput,
    serverErrorMessage: "",
    validators,
    debounce: 0,
    loaderVisible: false,
  }),
  components: {
    Loader,
  },
  computed: {
    formValues(): IFormInput[] {
      return Object.values(this.form);
    },
    disabled(): boolean | null | undefined {
      return (
        this.formValues.every((el: IFormInput) => el.valid === true) &&
        this.checkbox.valid &&
        !this.loaderVisible
      );
    },
  },
  methods: {
    validateInput(input: IFormInput, clear = true, isCheckbox = false): void {
      const validate = (): void => {
        const element: IFormInput = isCheckbox
          ? this.checkbox
          : this.formValues?.find(
              (formInput: IFormInput) => formInput.id === input.id
            ) || ({} as IFormInput);

        if (element.value === "") {
          element.valid = null;
          element.errorMessage = "";
          return;
        }

        element.valid = validators
          .find(
            (validator: IValidator) =>
              validator.name === element.validation?.condition
          )
          ?.validate(element.value);
        element.errorMessage = element.valid
          ? ""
          : element.validation?.errorMessage;
      };

      if (clear) {
        clearInterval(this.debounce);
      }

      this.debounce = setTimeout(validate, 500);
    },
    getInputClass(isValid: boolean | null): string {
      if (isValid === null) {
        return "";
      }
      return isValid ? "valid" : "invalid";
    },
    onSubmit() {
      const parsedFormData: IParsedFormData[] = this.formValues.map((v) => ({
        name: v.id,
        value: v.value,
      }));
      parsedFormData.push({
        name: this.textarea.id,
        value: this.textarea.value,
      });
      this.loaderVisible = true;
      this.$emit("onSubmit", parsedFormData);
    },
  },
});
